import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useSnackbarContext } from '../../context/snackbar.context';
import {
  FeeForServiceEvent,
  useGetBillsByFeeForServiceEventIdQuery,
  useGetContractsV2Query,
} from '../../types';
import LoadingComponent from '../utils/loading';
import BillList from './bill-list';
import { BillSource } from './bill-types';
export interface BillsByFeeForServiceIdProps {
  ffsData: FeeForServiceEvent;
}

const BillsByFeeForServiceId = ({
  ffsData,
}: BillsByFeeForServiceIdProps): JSX.Element => {
  const { setSnackbarState } = useSnackbarContext();
  const { data, loading, error } = useGetBillsByFeeForServiceEventIdQuery({
    variables: {
      sourceId: ffsData.id,
      source: BillSource.FEE_FOR_SERVICE_EVENTS,
    },
  });
  const contractsQuery = useGetContractsV2Query({
    variables: {
      contractIds: [ffsData.contractId],
      includeVoided: true,
      page: 1,
      size: 100,
    },
  });

  const contractCurrency = contractsQuery.data?.getContractsV2?.items.find(
    ({ id }) => id === ffsData.contractId,
  )?.currency;

  if (loading) {
    return <LoadingComponent center />;
  }

  if (error) {
    return (
      <HHAlert hhVariant="outlined" severity="error">
        <HHTypography hhVariant="body">
          There was an error loading fee for service bills
        </HHTypography>
      </HHAlert>
    );
  }

  if (!data?.getBillsByFeeForServiceEventId) {
    return (
      <HHStack spacing={2} overflow="hidden">
        <HHTypography hhVariant="body">
          Fee for service bills not found
        </HHTypography>
      </HHStack>
    );
  }

  if (!contractCurrency && !contractsQuery.loading) {
    setSnackbarState('Unable to load currency information', 'info', 3000);
  }

  return (
    <BillList
      billsData={data.getBillsByFeeForServiceEventId}
      currency={contractCurrency ?? null}
    />
  );
};

export default BillsByFeeForServiceId;
